module.exports = __webpack_public_path__ + "img/other04.b56c9ef6.png";